module.exports = __webpack_public_path__ + "img/bg-induce-01.d51b36be.png";